import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const token = window.localStorage.getItem('token') || ''

const state = {
  usuario: {},
  token,
  message: '',
  cliente: {},
  inIframe: window.self !== window.top
}

const mutations = {
  GET_USUARIO (state) {
    return state.usuario
  },

  SET_USUARIO (state, usuario) {
    state.usuario = usuario
  },

  GET_TOKEN (state) {
    return state.token
  },

  SET_TOKEN (state, token) {
    window.localStorage.setItem('token', token || '')
    state.token = token
  },

  GET_MESSAGE (state) {
    return state.message
  },

  SET_MESSAGE (state, message) {
    state.message = message
  },

  GET_CLIENTE(state) {
    return state.cliente
  },

  SET_CLIENTE(state, cliente) {
    state.cliente = cliente
  },

  GET_INIFRAME(state) {
    return state.inIframe
  }
}

const actions = {
  getUsuario ({ commit }) {
    commit('GET_USUARIO')
  },

  setUsuario ({ commit }, usuario) {
    commit('SET_USUARIO', usuario)
  },

  getToken ({ commit }) {
    commit('GET_TOKEN')
  },

  setToken ({ commit }, token) {
    commit('SET_TOKEN', token)
  },

  getMessage ({ commit }) {
    commit('GET_MESSAGE')
  },

  setMessage ({ commit }, message) {
    commit('SET_MESSAGE', message)
  },

  getCliente ({ commit }) {
    commit('GET_CLIENTE')
  },

  setCliente ({ commit }, cliente) {
    commit('SET_CLIENTE', cliente)
  },

  getInIframe({ commit }) {
    commit('GET_INIFRAME')
  },
}

const getters = {
  getUsuario: state => state.usuario,
  getToken: state => state.token,
  getMessage: state => state.message,
  getCliente: state => state.cliente,
  getInIframe: state => state.inIframe,
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters
})

export default store